module.exports = __webpack_public_path__ + "img/parralax-bg-1.10be799a.png";